import { useState, useEffect } from 'react';

function getStorageItem(name) {
  if (typeof window !== 'undefined' && window.localStorage) {
    return window.localStorage.getItem(name) || '';
  }
  return '';
}

// Kept for backwards compatibility with callers that previously read from cookies.
// The token (sessionId) and the isLoggedIn flag now live in localStorage.
function getCookie(name) {
  return getStorageItem(name);
}

function getIsLoggedIn() {
  const loggedIn = getStorageItem('isLoggedIn');
  return (loggedIn === 'true') || false;
}

function useAuthentication() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    setIsLoggedIn(getIsLoggedIn());
  });

  return [isLoggedIn];
}

const isLoggedIn = getIsLoggedIn();

export { useAuthentication, isLoggedIn, getCookie };
